'use strict';

fbLoadCategories.$inject = ["$rootScope", "common"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbLoadCategories = fbLoadCategories;
/*@ngInject*/
function fbLoadCategories($rootScope, common) {
    return {
        link: function link(scope) {
            if (scope.$last) {
                common.log.info('broadcast categories-loaded event');
                $rootScope.$broadcast('categories-loaded');
            }
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/fb-load-categories.js
// module id = 718
// module chunks = 0